export const IMAGES = {
  logo: "https://images.squarespace-cdn.com/content/v1/63bf72d4a4748471f3a19924/faa382b3-a267-4ff1-9b8b-5f1d9b33c750/hero+with+circle+background.png?format=1500w",
  logoColor: "https://customer-assets-eiarnc6j.emergentagent.net/job_student-campaigns-1/artifacts/axurisnb_hero-100.webp",
  logoBw: "https://customer-assets-eiarnc6j.emergentagent.net/job_student-campaigns-1/artifacts/n3xptuek_hero%20-%20black%20and%20white-100.webp",
  // 2026-08-16 — primary brand wordmark (all-black, transparent bg, w/ tasseled
  // cap glyph over the "M"). Used as the standalone lockup in the site header
  // and the footer brand column. The circular "logo" above is now reserved for
  // favicon + OG image only; no primary-nav use.
  logoWordmark: "https://customer-assets-eiarnc6j.emergentagent.net/job_student-campaigns-1/artifacts/goc7qjbn_hero%20-%20black%20and%20white.webp",
  hero: "https://customer-assets-eiarnc6j.emergentagent.net/job_student-campaigns-1/artifacts/yzi6fofh_iStock-1436152211.webp",
  walking: "https://customer-assets-eiarnc6j.emergentagent.net/job_student-campaigns-1/artifacts/uqeezg3f_iStock-1331300204%20%281%29.webp",
  ramen: "https://customer-assets-eiarnc6j.emergentagent.net/job_student-campaigns-1/artifacts/wgq1se7s_no-revisions-7aKbIqfIEMw-unsplash.webp",
  doodles: "https://customer-assets-eiarnc6j.emergentagent.net/job_student-campaigns-1/artifacts/wn00jo5t_black%20and%20white%20doodles.webp",
  founder: "https://images.squarespace-cdn.com/content/v1/63bf72d4a4748471f3a19924/db2b2201-bfee-49e6-a50f-f33a29b79965/GettyImages-1494066070.jpg",
  student1: "https://images.squarespace-cdn.com/content/v1/63bf72d4a4748471f3a19924/328a9918-c69b-40b8-8265-3dbb639bd3b0/iStock-521264553.jpg",
  student2: "https://images.squarespace-cdn.com/content/v1/63bf72d4a4748471f3a19924/8638191b-3299-4ccc-b335-315900deb886/iStock-1183330263.jpg",
  group: "https://images.squarespace-cdn.com/content/v1/63bf72d4a4748471f3a19924/9ed15bc9-2647-4b63-9224-7c20d48722e1/iStock-1150924325.jpg",
  campus: "https://images.squarespace-cdn.com/content/v1/63bf72d4a4748471f3a19924/1688496576737-0SPJ14SB6Z9A7KKARBKH/iStock-1331300204.jpg",
  lifestyle: "https://images.squarespace-cdn.com/content/v1/63bf72d4a4748471f3a19924/fc211aa0-c658-442f-ac94-494238d5792f/omid-armin-a5EbQpl-IHw-unsplash.jpg",
  pattern: "https://customer-assets-eiarnc6j.emergentagent.net/job_student-campaigns-1/artifacts/1gi7hsnk_logo%20pattern.webp",
  cap: "/cap.png",
  // 2026-02-23 — new smiling headshot for Ways To Give / testimonial tiles
  portraitWarm: "https://customer-assets-eiarnc6j.emergentagent.net/job_student-campaigns-1/artifacts/kk5tykok_Screenshot%202026-07-22%20at%203.06.59%E2%80%AFPM.png",
  // 2026-02-23 — hands-on-laptop overhead shot for HowItWorks step 01
  buildingLaptop: "https://customer-assets-eiarnc6j.emergentagent.net/job_student-campaigns-1/artifacts/n78tk7av_Hands%20typing%20on%20laptop%20with%20phone%20-%206720x4480.webp",
  // 2026-02-23 — friends around a table for Manifesto chapter 01 (warm community moment)
  friendsTable: "https://customer-assets-eiarnc6j.emergentagent.net/job_student-campaigns-1/artifacts/ir594jp1_Women%20and%20friends%20-%205184x3456.webp",
  // 2026-02-24 — intergenerational hand-holding for Manifesto chapter 01 (aunt & niece walking together)
  handsHeld: "https://customer-assets-eiarnc6j.emergentagent.net/job_student-campaigns-1/artifacts/z7t6fum5_iStock-2222785712.webp",
  // 2026-02-24 — donate keyboard key for HowItWorks step 03 (donors fund what matters)
  donateKey: "https://customer-assets-eiarnc6j.emergentagent.net/job_student-campaigns-1/artifacts/dz7peqvn_iStock-637945860.webp",
  // 2026-02-24 — red-haired student on stone steps for WaysToGive Path 01 (a real student to back)
  studentSteps: "https://customer-assets-eiarnc6j.emergentagent.net/job_student-campaigns-1/artifacts/m17r8e9z_iStock-1141224094%20png.webp",
  // 2026-02-24 — student parent studying with baby for Manifesto chapter 02 (opportunity shouldn't carry a price tag)
  studentParent: "https://customer-assets-eiarnc6j.emergentagent.net/job_student-campaigns-1/artifacts/bzxfu8m2_iStock-1329262442.webp",
  // 2026-02-24 — medical students group for WaysToGive Path 02 (give to the fund — many students reached)
  medStudents: "https://customer-assets-eiarnc6j.emergentagent.net/job_student-campaigns-1/artifacts/0bguwfkw_iStock-2222581597.webp",
  // 2026-02-24 — classroom hand-raise for WaysToGive Path 02 (many students supported by the fund)
  classroomHandUp: "https://customer-assets-eiarnc6j.emergentagent.net/job_student-campaigns-1/artifacts/st1101i7_iStock-1307457391.webp",
  // 2026-02-24 — first-gen freshman on move-in day (holding rolled rug + red milk crate) for Carlos S. campaign
  carlos: "https://customer-assets-eiarnc6j.emergentagent.net/job_student-campaigns-1/artifacts/crm6wdvl_iStock-83375984.webp",
  // 2026-02-24 — young man taking a selfie by a car for James T.'s campaign
  james: "https://customer-assets-eiarnc6j.emergentagent.net/job_student-campaigns-1/artifacts/nu6q83kq_iStock-494934773.webp",
  // 2026-02-24 — joyful "goal met" moment for HowItWorks step 03 (donors fund what matters — replaces stock donate key)
  goalMet: "https://customer-assets-eiarnc6j.emergentagent.net/job_student-campaigns-1/artifacts/z1zyxfoh_GettyImages-1494066070.webp",
  // 2026-02-24 — UCLA Royce Hall for HowItWorks step 02 (verified accredited campus, replaces Stanford arcade)
  campusHall: "https://customer-assets-eiarnc6j.emergentagent.net/job_student-campaigns-1/artifacts/epmihbqf_iStock-2188703162.webp",
  // 2026-02-24 — Marcus J. campaign portrait (young man in winter puffer coat on cobblestone)
  marcus: "https://customer-assets-eiarnc6j.emergentagent.net/job_student-campaigns-1/artifacts/2da4n2l0_Man%20outdoor%20with%20jacket%20-%204480x6720.webp",
  // 2026-02-24 — yellow oval/scallop pattern (Impact → Featured band prototype)
  ovalPattern: "https://customer-assets-eiarnc6j.emergentagent.net/job_student-campaigns-1/artifacts/22b8cb2u_IMG_0605.webp",
};

export const HERO_SLIDES = [
  {
    src: "https://customer-assets-eiarnc6j.emergentagent.net/job_student-campaigns-1/artifacts/yzi6fofh_iStock-1436152211.webp",
    alt: "A freshman arriving at their dorm on move-in day",
    caption: "Move-in day. And the beginning of everything.",
  },
  {
    src: "https://customer-assets-eiarnc6j.emergentagent.net/job_student-campaigns-1/artifacts/uqeezg3f_iStock-1331300204%20%281%29.webp",
    alt: "Four students walking together on a campus path, laughing",
    caption: "The people who become your reason to stay.",
  },
  {
    src: "https://customer-assets-eiarnc6j.emergentagent.net/job_student-campaigns-1/artifacts/wgq1se7s_no-revisions-7aKbIqfIEMw-unsplash.webp",
    alt: "A student reading a novel over a cup of ramen",
    caption: "3 a.m. And still finding a way through.",
  },
  {
    src: "https://customer-assets-eiarnc6j.emergentagent.net/job_student-campaigns-1/artifacts/ncxgv36s_iStock-1362815533.webp",
    alt: "Graduates in silhouette at sunset, diplomas raised toward the sky",
    caption: "Graduation day. And a promise kept.",
  },
];

export const NAV_LINKS = [
  { label: "How it works", href: "#how" },
  { label: "About", href: "/team" },
  { label: "Campaigns", href: "/demo#campaigns" },
  { label: "FAQs", href: "/faq" },
];

// Social handles — update hrefs once the accounts exist. Rendered in the
// footer "Say hello" column and the contact success state.
// Founder (2026-09-13): hide every social handle until the accounts exist. Flip to true to show them.
export const SOCIAL_LINKS_LIVE = false;

export const SOCIAL_LINKS = [
  { id: "instagram", label: "Instagram", href: "https://instagram.com/myrichaunt" },
  { id: "tiktok", label: "TikTok", href: "https://tiktok.com/@myrichaunt" },
  { id: "linkedin", label: "LinkedIn", href: "https://linkedin.com/company/myrichaunt" },
  { id: "facebook", label: "Facebook", href: "https://facebook.com/myrichaunt" },
];

export const MANIFESTO = [
  {
    no: "01",
    title: "Everyone remembers",
    italic: "the one who showed up.",
    accent: "text-cobalt",
    body: "An aunt who slipped you grocery money. A coach who quietly covered a fee. My Rich Aunt is a chance to be that person for a student today, and a place where students can ask for help without feeling embarrassed.",
  },
  {
    no: "02",
    title: "Opportunity shouldn't",
    italic: "carry a price tag.",
    accent: "text-grass",
    body: "Internships. A semester abroad. A laptop that actually works. The kinds of experiences that launch careers usually don't fit inside a financial aid award. We help students reach them anyway.",
  },
  {
    no: "03",
    title: "Real help,",
    italic: "given with dignity.",
    accent: "text-blossom",
    body: "No red tape, nothing to be embarrassed about. Verified students tell us what they need, and our community of \u201Caunties and uncles\u201D helps My Rich Aunt make it happen.",
  },
];

// STEPS drives the LEFT column of the unified "How It Works" band —
// the STUDENT-facing side. Voice: second-person, addressed directly
// to a student ("your campaign", "your future aunties and uncles").
// The "aunties and uncles" metaphor introduced in row 1 threads
// through the whole column and echoes the "My Rich Aunt" brand name.
export const STEPS = [
  {
    no: "01",
    title: "Create your campaign.",
    body: "Tell your future aunties and uncles who you are, what you need, and why it matters. Video, essay or photos.",
  },
  {
    no: "02",
    title: "Enrollment confirmed.",
    body: "Before you go live, we confirm your enrollment through the National Student Clearinghouse.",
  },
  {
    no: "03",
    title: "Help arrives.",
    body: "Once you're verified, grants arrive on a regular schedule. No waiting for a campaign to close.",
  },
];

export const FUNDS = [
  { note: "when it matters", title: "The trip home", body: "A seat on the flight for the holidays or a family emergency." },
  { note: "beyond campus", title: "A semester abroad", body: "The passport stamps and perspective a financial aid award doesn't stretch to cover." },
  { note: "day one", title: "Move-in essentials", body: "Bedding, a winter coat, a working laptop. The things that turn a dorm room into a place to live." },
  { note: "for the coursework", title: "Books and tools", body: "Textbooks, software, and the equipment a course actually needs." },
];

export const SAMPLE_VIDEO = "https://storage.googleapis.com/gtv-videos-bucket/sample/ForBiggerJoyrides.mp4";

// TODO(backend): Replace CAMPAIGNS export with an API-driven store.
//   Expected endpoint:   GET /api/campaigns  ->  Campaign[]
//   Single campaign:     GET /api/campaigns/:id
//   Consumers today:     pages/CampaignDetail.jsx (by numeric array index),
//                        components/EndingSoon.jsx, components/FeaturedCampaigns.jsx
//   When wiring the real backend, keep this array as the fallback used when
//   `isDemoMode()` returns true (see lib/demoMode.js).
export const CAMPAIGNS = [
  {
    name: "Maya R.",
    school: "Stanford University",
    major: "Biology, Class of '27",
    gradYear: "2027",
    headline: "I am a student at Stanford University",
    story: "A summer research fellowship could shape my entire career. I'm raising what my aid package won't cover so I can say yes to a once-in-a-lifetime lab placement, buy the equipment I need, and cover the cost of living near campus for the summer.",
    goal: 2000, raised: 1680, daysLeft: 12, img: "student1",
    category: "internship",
    gallery: ["student1", "campus", "lifestyle"],
    video: SAMPLE_VIDEO,
    donations: [
      { name: "Anonymous", amount: 100, date: "Jun 22, 2026" },
      { name: "The Bell Family", amount: 250, date: "May 29, 2026" },
      { name: "Madhupa Inc.", amount: 80, date: "May 27, 2026" },
    ],
  },
  {
    name: "Andre W.",
    school: "Howard University",
    major: "Computer Science, Class of '28",
    gradYear: "2028",
    headline: "I am a student at Howard University",
    story: "A working laptop and a ticket to my first tech conference would open doors I've been knocking on for years. Your support helps me buy reliable hardware and travel to the events where I can meet mentors and future employers.",
    goal: 1800, raised: 940, daysLeft: 21, img: "student2",
    category: "tech",
    gallery: ["student2", "group", "campus"],
    video: SAMPLE_VIDEO,
    donations: [
      { name: "Anonymous", amount: 50, date: "Jun 18, 2026" },
      { name: "K. Sparks", amount: 150, date: "Jun 02, 2026" },
      { name: "Codrington Fund", amount: 100, date: "May 24, 2026" },
    ],
  },
  {
    name: "Zohran M.",
    school: "UC Berkeley",
    major: "International Relations, Class of '27",
    gradYear: "2027",
    headline: "I am a student at UC Berkeley",
    story: "A semester studying in Nairobi would change how I see the world, and my future. I'm almost at my goal. Funds cover my program fee, visa, and travel so I can focus on the work instead of the bill.",
    goal: 2000, raised: 1750, daysLeft: 1, img: "group",
    category: "study-abroad",
    gallery: ["group", "lifestyle", "campus"],
    video: SAMPLE_VIDEO,
    donations: [
      { name: "Anonymous", amount: 200, date: "Jun 20, 2026" },
      { name: "J. Peeples", amount: 100, date: "Jun 11, 2026" },
      { name: "Onyema Family", amount: 150, date: "Jun 04, 2026" },
    ],
  },
  {
    name: "Sarah T.",
    school: "Brown University",
    major: "English Literature, Class of '28",
    gradYear: "2028",
    headline: "I am a student at Brown University",
    story: "Starting freshman year in Providence without the basics is harder than people realize. I'm raising money for bedding, a desk lamp, and the winter coat I don't own yet. Small things, but they'll let me focus on my classes instead of what I don't have.",
    goal: 1200, raised: 620, daysLeft: 18, img: "friendsTable",
    category: "housing",
    gallery: ["friendsTable", "campus", "student1"],
    video: SAMPLE_VIDEO,
    donations: [
      { name: "Anonymous", amount: 40, date: "Jun 15, 2026" },
      { name: "T. James", amount: 100, date: "Jun 08, 2026" },
      { name: "P. Codrington", amount: 60, date: "May 30, 2026" },
    ],
  },
  {
    name: "Marcus J.",
    school: "Prairie View A&M University",
    major: "Pre-Med, Class of '27",
    gradYear: "2027",
    headline: "I am a student at Prairie View A&M University",
    story: "MCAT prep books, organic chemistry textbooks, and a used tablet for my study notes — pre-med is expensive and my scholarship doesn't cover any of it. I'm asking for help so I can actually keep up with my cohort instead of falling behind.",
    goal: 900, raised: 380, daysLeft: 27, img: null, paletteVariant: "cobalt",
    category: "books",
    gallery: [],
    video: SAMPLE_VIDEO,
    donations: [
      { name: "Anonymous", amount: 30, date: "Jun 20, 2026" },
      { name: "A. Onyema", amount: 100, date: "Jun 10, 2026" },
      { name: "K. Sparks", amount: 50, date: "May 28, 2026" },
    ],
  },
  {
    name: "Elena K.",
    school: "University of Michigan",
    major: "Public Health, Class of '26",
    gradYear: "2026",
    headline: "I am a first-generation student at University of Michigan",
    story: "I made it to senior year; I'm the first in my family to finish college. Now I need a cap, gown, and honor cords.",
    goal: 1400, raised: 1120, daysLeft: 9, img: "studentParent",
    category: "graduation",
    gallery: ["studentParent", "campus", "group"],
    video: SAMPLE_VIDEO,
    donations: [
      { name: "The Peeples Family", amount: 200, date: "Jun 21, 2026" },
      { name: "Anonymous", amount: 100, date: "Jun 14, 2026" },
      { name: "H. Sparks", amount: 80, date: "Jun 01, 2026" },
    ],
  },
  {
    name: "Carlos S.",
    school: "Cal State Dominguez Hills",
    major: "Political Science, Class of '28",
    gradYear: "2028",
    headline: "I am a first-generation freshman at Cal State Dominguez Hills",
    story: "I'm the first in my family to go to college. My scholarship covers tuition but not the small things nobody warned me about — orientation fees, a printer for the dorm, a bus pass, the textbook access codes professors add on top of the books. I'm asking my extended family (that's you) to help me start freshman year without falling behind on day one.",
    goal: 1600, raised: 520, daysLeft: 24, img: "carlos",
    category: "first-gen",
    gallery: ["carlos", "campus", "lifestyle"],
    video: SAMPLE_VIDEO,
    donations: [
      { name: "Anonymous", amount: 40, date: "Jun 19, 2026" },
      { name: "L. Ambriz", amount: 100, date: "Jun 10, 2026" },
      { name: "H. Sparks", amount: 60, date: "May 30, 2026" },
    ],
  },
  {
    name: "Ethan L.",
    school: "St. John's University - MN",
    major: "Environmental Studies, Class of '28",
    gradYear: "2028",
    headline: "I am a student at St. John's University - MN",
    story: "I grew up in Phoenix and I'm headed to Collegeville for freshman year. I've never owned a real winter coat, snow boots, or gloves that survive past October. I'm asking for help covering the essentials so my first Minnesota winter doesn't become the reason I have to quit.",
    goal: 850, raised: 310, daysLeft: 15, img: null, paletteVariant: "tangerine",
    category: "winter-gear",
    gallery: [],
    video: SAMPLE_VIDEO,
    donations: [
      { name: "Anonymous", amount: 40, date: "Jun 22, 2026" },
      { name: "T. Crigler", amount: 120, date: "Jun 09, 2026" },
      { name: "The Codrington Fund", amount: 75, date: "May 26, 2026" },
    ],
  },
  {
    name: "James T.",
    school: "Washington State University",
    major: "Neuroscience, Class of '27",
    gradYear: "2027",
    headline: "I am a student at Washington State University",
    story: "I've wanted to be a doctor since I was ten. But an MCAT prep course, the practice tests, and the AAMC bundle add up to more than a whole summer of paychecks. I'm asking for help so I can walk into that exam room with the same preparation my classmates already have.",
    goal: 1500, raised: 640, daysLeft: 22, img: "james",
    category: "test-prep",
    gallery: ["james", "campus", "group"],
    video: SAMPLE_VIDEO,
    donations: [
      { name: "Anonymous", amount: 60, date: "Jun 21, 2026" },
      { name: "J. Peeples", amount: 150, date: "Jun 12, 2026" },
      { name: "A. Ambriz", amount: 80, date: "May 28, 2026" },
    ],
  },
];

export const EXPENSE_GUIDELINES = (
  <>
    <div>
      <p className="font-semibold text-ink">Approved student expenses</p>
      <p className="mt-1">Approved uses include the following education-related and student-living costs:</p>
      <ul className="mt-3 list-disc space-y-1.5 pl-5 marker:text-tangerine">
        <li>
          <span className="font-medium text-ink">Housing &amp; dorm essentials:</span>{" "}
          Bedding (blankets, sheets, pillows), mattress pads, towels, desk lamps, or mini-fridges.
        </li>
        <li>
          <span className="font-medium text-ink">Winter &amp; campus apparel:</span>{" "}
          Cold-weather gear needed for the student&rsquo;s campus climate, including winter coats, boots, gloves, and professional attire for interviews.
        </li>
        <li>
          <span className="font-medium text-ink">Campus &amp; professional engagement:</span>{" "}
          Membership dues for official campus organizations, professional societies, or student-led academic clubs.
        </li>
        <li>
          <span className="font-medium text-ink">Global education &amp; study abroad:</span>{" "}
          Luggage, travel backpacks, passport/visa fees, and mandatory international health insurance.
        </li>
        <li>
          <span className="font-medium text-ink">Study abroad living costs:</span>{" "}
          Supplemental funds for food, local transit, and housing costs incurred while studying outside the student&rsquo;s home campus.
        </li>
        <li>
          <span className="font-medium text-ink">Technology &amp; academic supplies:</span>{" "}
          Laptop repairs, software subscriptions required for class, Wi-Fi hotspots, calculators, or printer ink.
        </li>
        <li>
          <span className="font-medium text-ink">Daily needs &amp; commuting:</span>{" "}
          Groceries, campus dining gap payments, subway/bus passes, and gas money for commuting to class.
        </li>
      </ul>
    </div>

    <div>
      <p className="font-semibold text-ink">Prohibited expenses</p>
      <p className="mt-1">The following items do not qualify for funding under our 501(c)(3) guidelines and cannot be funded under any circumstances:</p>
      <ul className="mt-3 list-disc space-y-1.5 pl-5 marker:text-scarlet">
        <li>
          <span className="font-medium text-ink">Family &amp; guest travel:</span>{" "}
          Airfare, hotels, or transit for parents, siblings, or guests to visit campus or attend the student&rsquo;s graduation.
        </li>
        <li>
          <span className="font-medium text-ink">Direct tuition &amp; mandatory university fees:</span>{" "}
          Any balance directly paid to the bursar&rsquo;s office that is traditionally covered by standard financial aid.
        </li>
        <li>
          <span className="font-medium text-ink">Entertainment &amp; leisure:</span>{" "}
          Concert or movie tickets, vacation travel (unrelated to study abroad), gym memberships outside of school, or streaming subscriptions.
        </li>
        <li>
          <span className="font-medium text-ink">Fines, penalties, &amp; legal fees:</span>{" "}
          Campus parking tickets, library late fees, course registration penalties, or legal costs.
        </li>
        <li>
          <span className="font-medium text-ink">Cash gifts to others:</span>{" "}
          Using the funds to purchase gifts, loans, or financial support for friends, family members, or classmates.
        </li>
      </ul>
    </div>
  </>
);

export const FAQS = [
  {
    group: "general",
    q: "Are the campaigns on the site real?",
    a: "Not yet. While the platform is in preview, every campaign you see is a sample built to show how student campaigns will work. The students are not real and no sample accepts gifts. The General Fund is live and tax-deductible, and verified student campaigns open with our first cohort. Join the waitlist on the Contact page to hear the day they do.",
  },
  {
    group: "general",
    q: "Is My Rich Aunt a registered non-profit?",
    a: "Yes. We're a 501(c)(3) not-for-profit, so every donation made through the platform is tax-deductible.",
  },
  {
    group: "general",
    q: "How do you verify students?",
    a: (
      <>
        Before any fundraising campaign goes live, we confirm that each student is currently enrolled at an accredited college or
        university through the{" "}
        <a
          href="https://www.nationalstudentclearinghouse.org"
          target="_blank"
          rel="noopener noreferrer"
          className="font-medium text-tangerine underline underline-offset-4 transition-colors hover:text-cobalt"
        >
          National Student Clearinghouse
        </a>
        , the same enrollment authority trusted by schools and employers nationwide.
      </>
    ),
  },
  {
    group: "students",
    q: "Who can create a campaign?",
    a: "Students creating campaigns must be U.S. residents, 18 years or older with U.S bank accounts, and a social security or individual taxpayer identification number. Only the enrolled student who will personally receive the grant can create a campaign. My Rich Aunt does not permit parents, siblings, guardians, friends, classmates, or any third party to create a campaign on a student's behalf.",
  },
  {
    group: "donors",
    q: "How are donations processed?",
    a: "Every donation goes to My Rich Aunt as a 501(c)(3) organization. Your gift supports our supplemental educational grant program. When you highlight a student on our platform, we treat that as a non-binding preference. Final grant decisions rest with My Rich Aunt. We receive the funds, send you a tax-deductible receipt, and award grants to verified students who meet our criteria, in line with our program guidelines.",
  },
  {
    group: "donors",
    q: "What can grant funds be used for?",
    a: (
      <div className="space-y-6">
        <p>
          Grants issued through My Rich Aunt&rsquo;s supplemental educational
          grant program are for education-related and student-living costs
          incurred while enrolled that are not already covered by financial
          aid. For grants of $500 or less we rely on each student&rsquo;s
          legally binding certification at signup; larger grants may require
          documentation at our administrators&rsquo; discretion.
        </p>
        {EXPENSE_GUIDELINES}
      </div>
    ),
  },
  {
    group: "students",
    q: "How and when do students receive the funds?",
    a: "My Rich Aunt awards grants to verified students every week. Students don't have to wait for their campaign to end: as gifts to My Rich Aunt come in, grants go out in the next weekly batch.",
  },
  {
    group: "general",
    q: "What happens if a campaign doesn't reach its goal?",
    a: "Campaigns aren't all or nothing. My Rich Aunt awards grants weekly from the gifts the My Rich Aunt family makes. If a campaign ends without hitting its goal based on donor preferences, My Rich Aunt will issue a grant to satisfy the full goal amount (or come as close as possible based on available My Rich Aunt funds).",
  },
  {
    group: "students",
    q: "Is there a cap on how much a student can receive?",
    a: "Yes. During our beta launch, student campaigns are capped at $500 in any 12-month period, so the help stays available to as many students as possible. This cap will be increased after we've raised funds for a full pilot launch. Every campaign also has a set length, so pages stay current.",
  },
  {
    group: "students",
    id: "expense-guidelines",
    q: "What can students raise money for?",
    a: <div className="space-y-6">{EXPENSE_GUIDELINES}</div>,
  },
  {
    group: "donors",
    id: "who-receives",
    q: "Who receives my donation?",
    a: "My Rich Aunt does. Every donation, whether you name a student you'd like to help or give to the general fund, is made to My Rich Aunt, a 501(c)(3) organization, and is tax-deductible. My Rich Aunt then awards grants from those funds to verified students who meet our criteria. Naming a student is a non-binding preference that guides us; the grant decision is always ours.",
  },
  {
    group: "students",
    q: "Is there a fee for students to start a campaign?",
    a: "No. Starting a campaign is free for verified students. We're here to make it easier.",
  },
];


export const FOUNDER = {
  name: "Terri James",
  role: "Founder & Board Chair",
  accent: "text-tangerine",
  tape: "bg-yellow",
  school: "Harvard Law School",
  // 2026-09-13 — current headshot (founder-supplied, cropped 4:5 for the "today" frame)
  photoNow: "/founder-now.webp",
  photoThen: "/founder-then.webp",
  eyebrow: "our story",
  heading: "She made it to Stanford and Harvard, and never forgot what it {cost} to get there.",
  headingAccent: "cost",
  // Renders as the underline swash color under the accent phrase.
  // Consumed by <EmSwash color={...}> in Team.jsx (FounderSpotlight).
  headingAccentColor: "text-cobalt",
  story: [
    "Terri James grew up in working-class Los Angeles and made her way through public schools to Stanford, then Harvard Law. She also knew the quiet math of getting by: borrowing textbooks she couldn't buy, skipping study abroad, and getting through her first New England winter in a thin jacket until a work-study check finally paid for a real coat.",
    "Her career began at Paul, Weiss as a litigation associate, with early roles at the ACLU and the Center for Reproductive Rights. She later moved in-house across media and entertainment \u2014 E!, BBC America, NBCUniversal, Viacom (now Paramount Skydance) \u2014 and today, she's at HBO.",
    "Long before My Rich Aunt existed, she was already running informal fundraisers for students who crossed her path. For her own nieces and nephews, that generosity shows up as impromptu shopping trips and proverbial checks in cards.",
    "Far from rich herself, Terri built My Rich Aunt because she knows how much a small, well-timed gift from someone who cares can help. Her hope: a community of generous \u2018aunts and uncles\u2019 will feel the same way and step in with real support without ever making a student feel embarrassed for needing a little help.",
  ],
  // Punchy caption sits under the polaroid pair; leave blank for now —
  // Terri is drafting a replacement line. When present, it's rendered
  // as an italic sub-caption under the founder photo (see Team.jsx).
  captionQuote: "",
  // Terri's personal ethos, doubling as the site's Hero headline.
  // Featured as an editorial pull-quote at the end of Our Story so
  // donors reading her bio hear the mission in her voice. The `{…}`
  // brackets mark the phrase that receives the tangerine EmSwash
  // underline (mirrors the `heading` / `headingAccent` pattern above).
  pullQuote: "Think back; pay it {forward.}",
  pullQuoteAccent: "forward.",

  // A single italic line that sits above Terri's signature in the
  // Home footer CTA band ("Join the My Rich Aunt Family."). It's the
  // last thing a visitor reads before the signature — meant to feel
  // signed by her, not written by us. Edit here to change everywhere.
  footerSignoff: "This is your chance to be the person you needed.",
};

export const BOARD = [
  {
    name: "Adriana Ambriz",
    role: "Board Secretary",
    accent: "text-cobalt",
    tape: "bg-blossom",
    school: "Brown University",
    photoThen: "/adriana-then.webp",
    photoNow: "https://customer-assets-eiarnc6j.emergentagent.net/job_student-campaigns-1/artifacts/kyp5tmjr_Adriana0054.jpeg",
    bio: "Adriana Ambriz began her film career in the Agent Trainee program at Creative Artists Agency, then joined 20th Century Fox as a Creative Executive on films including We Bought a Zoo, X-Men: First Class and The A-Team. As an independent producer she helped develop the documentary Contra el Reloj and the comedy Bloodsucking Bastards, and produced for Germany's Construction Film, whose slate included Werner Herzog, Marc Forster and Tony Kaye. At BET Networks she was Senior Director of Original Programming, overseeing Tales, Street Dreams: The Story of Nas and Mandela, before joining One Community to develop and produce features including Respect.\n\nToday Adriana is Head of Development at Joy Mill Entertainment, Tracee Ellis Ross's production company, which she joined at its start in 2020. Her projects there include Solo Traveling with Tracee Ellis Ross (Roku), The Hair Tales (Onyx), Jodie (MTV), the podcast I Am America and Power of the Dream (Amazon). She is also Executive Producer of the award-winning podcast Our Ancestors Were Messy.\n\nAs a student, Adriana worked in education and youth programs for high-risk, low-income young people in her own South Central Los Angeles neighborhood. She holds a B.A. in 20th Century English Literature from Brown University.",
  },
  {
    name: "Keith Sparks",
    role: "Board Member",
    accent: "text-grass",
    tape: "bg-yellow",
    school: "Stanford University",
    photoNow: "/keith-now.webp",
    photoThen: "/keith-then.webp",
    bio: "Keith Sparks has spent his career developing, financing and running complex energy infrastructure businesses, alongside substantial M&A and venture capital work. As a private investor he backs businesses with predictable, long-term cash flows and real downside protection, and he advises renewable energy developers and government officials on infrastructure, community outreach, privatization and finance.\n\nMany of the deals Keith led were the first of their kind and still outperform the market: the first independent power project in sub-Saharan Africa (Nigeria, 2001) and the largest integrated wind project in the Western Hemisphere (New Mexico, 2021). Recent work includes a sub-sea transmission project in Europe, converting decommissioned industrial sites to renewables, and developing U.S. farmland into powered data-center sites.\n\nBefore energy, Keith was Assistant Athletic Director at Stanford University, working with elite athletes, coaches and the admissions office. That work grew into a start-up professional basketball league that helped bring about California's first Name, Image and Likeness (NIL) law, now the template for college athletes nationwide. He holds an A.B. in Human Biology from Stanford and a J.D. from the University of Texas School of Law.",
  },
  {
    name: "Trinity Crigler",
    role: "Board Treasurer",
    accent: "text-blossom",
    tape: "bg-grass",
    school: "Washington State University",
    bio: "Trinity Crigler has worked in corporate finance for 25 years. She's Controller at Olea Kiosks, a privately held technology-services company, where she built the finance team from scratch and now sits on the executive team.\n\nShe joined our board after a few conversations with college students who were doing everything right and still couldn't quite catch their breath around money. Trinity has been there. Her Christian faith taught her that money is a tool, and she wants young people to have it working for them from the start. On weekends she mentors college-aged women on the practical stuff: budgeting, planning, and the small habits that add up.\n\nTrinity holds a B.A. in Business Administration from Washington State University and is a member of Delta Sigma Theta Sorority, Inc. When she's not at work, she and her husband are usually somewhere new with glasses of wine in hand.",
  },
  {
    name: "Marie Milnes-Vasquez",
    role: "Board Member",
    accent: "text-tangerine",
    tape: "bg-cobalt",
    school: "California State University, Fullerton",
    photoNow: "/marie-now.webp",
    photoThen: "/marie-then.webp",
    bio: "Marie Milnes-Vasquez is managing director of EY's National Tax Mergers and Acquisitions Group, where she advises multinational companies on the U.S. tax implications of their transactions and structurings. She joined EY after more than two decades as a lawyer at the Internal Revenue Service, where she drafted official IRS guidance and advised on high-profile tax litigation. Before her government service, Marie worked at Baker & McKenzie, advising multinationals on cross-border transactions.\n\nMarie grew up in working class, Latino neighborhoods of Los Angeles, and, without support for her studies, she worked her way through college. Without resources, she did not have the chance to experience her undergraduate educational dreams, including studying abroad. As a legal professional and parent, she has had the privilege of providing opportunities to her own children, as well as supporting the educational needs of her nieces and nephews.\n\nMarie earned her B.A. at California State University, Fullerton, her J.D. at Harvard Law School, and her LL.M. (tax) at Georgetown University Law Center. She clerked for a federal judge before moving into private practice.",
  },
];

export const ADVISORS = [
  {
    name: "Penelope Codrington",
    role: "Advisor",
    accent: "text-cobalt",
    tape: "bg-blossom",
    school: "Harvard College",
    photoNow: "/penelope-now.webp",
    photoThen: "https://customer-assets-eiarnc6j.emergentagent.net/job_student-campaigns-1/artifacts/7e7q7qsx_WhatsApp%20Image%202026-08-27%20at%2007.29.04.jpeg",
    bio: "Penelope is an attorney who has worked domestically and overseas solving legal, compliance and management challenges for business and non-profit organizations. Remembering her relief after receiving a scholarship which paid for her college textbooks, she is delighted to help students feel supported and equipped to focus on their studies. Penelope graduated from Harvard College and Harvard Law School.",
  },
  {
    name: "Afam Onyema",
    role: "Advisor",
    accent: "text-blossom",
    tape: "bg-yellow",
    school: "Stanford Law School",
    photoNow: "https://customer-assets-eiarnc6j.emergentagent.net/job_student-campaigns-1/artifacts/zulfx7cg_Afam%20Headshot%203.webp",
    nowFocusX: 20, // slide the wide podium shot left so the "then" polaroid clears the G of the GEANCO sign
    bio: "Afam Onyema is Co-Founder and CEO of the GEANCO Foundation, which saves and transforms lives in Nigeria. GEANCO delivers life-saving surgeries and runs education programs across Nigeria, from cleft-lip repairs to scholarships that send girls to school. After graduating from Harvard University and Stanford Law School, Afam declined multiple lucrative corporate law firm offers in order to create and run GEANCO full-time.",
  },
  {
    name: "John Peeples",
    role: "Advisor",
    accent: "text-grass",
    tape: "bg-blossom",
    school: "",
    bio: "Bio coming soon.",
  },
  {
    name: "Haley Sparks",
    role: "Advisor",
    accent: "text-tangerine",
    tape: "bg-yellow",
    school: "University of Michigan",
    photoNow: "/haley-now.webp",
    bio: "Haley Sparks, PhD, MSW, is a psychologist, social worker, and Ease and Enjoyment coach who helps people show up better with each other. She's the inaugural Director of Community and Organizational Development at UCLA, in the External Affairs division. Before UCLA and coaching, she spent years as a therapist for individuals, couples, families, and groups. Haley earned her PhD in Psychology and her MSW at the University of Michigan.",
  },
];
